// import dependencies
import css from 'dom-css'
import classes from 'dom-classes'
import raf from 'raf'

/*
 *  ==== ScrollMixin ====
 */

const ScrollMixin = {

	created: function () {
		this.$bus.$on('transitioner:visible', this.destroy)
	},

	methods: {
		initScroll: function (options) {
			this.options = options
			this.body = document.body
			this.elementsContainer = this.options.container
			this.elements = this.options.elements
			this.elementsLength = this.elements.length
			this.halfViewport = this.options.middle

			let array = Array.prototype.slice.call(this.elements).reverse()
			this.elements = array

			this.acceleration = []
			this.velocity = []
			this.inMotion = []
			this.newTop = []
			this.NewPositions = []
			this.Positions = []
			this.opacity = []

			this.stiffness = 28
			this.friction = 9
			this.threshold = 2

			this.animating = false
			this.frameRate = 1 / 60

			this.scrollY = 0
			this.lastScrollY = 0

			this.handlers = {}
			this.raf = null

			this.timer = null
			this.ticking = false

			this.reflow()
			this.addScrollEvents()
		},
		reflow: function () {
			classes.add(this.elementsContainer, 'fixed')

			this.reset()

			var bodyRect = this.body.getBoundingClientRect()

			for (var i = 0; i < this.elementsLength; i++) {
				var currentItem = this.elements[i]
				this.Positions[i] = currentItem.getBoundingClientRect().top + this.halfViewport - bodyRect.top
				this.NewPositions[i] = this.Positions[i]
				this.newTop[i] = this.Positions[i]
				this.inMotion[i] = true
				this.acceleration[i] = 0
				this.velocity[i] = 0

				css(currentItem, {
					'position': 'absolute',
					'top': this.Positions[i] + 'px'
				})
			}
		},
		reset: function () {
			this.acceleration = []
			this.velocity = []
			this.inMotion = []
			this.newTop = []
			this.NewPositions = []
			this.Positions = []
			this.opacity = []

			for (var i = 0; i < this.elementsLength; i++) {
				css(this.elements[i], {
					'position': 'relative',
					'transform': 'translate3d(0,0,0)',
					'opacity': 1
				})
			}
		},
		onScrolling: function () {
			this.scrollY = window.scrollY
			if (!this.animating) {
				clearTimeout(this.timer)

				if (!this.ticking) {
					this.ticking = true
					this.body.classList.add('is-scrolling')
				}

				this.timer = setTimeout(function () {
					this.ticking = false
					this.body.classList.remove('is-scrolling')
				}.bind(this), 200)

				// set css from last calucation
				for (var i = 0; i < this.elementsLength; i++) {
					this.inMotion[i] = true
				}

				// debouncing raf
				this.animating = true
				this.raf = raf(this.run.bind(this))
			}
		},
		run: function () {
			for (var i = 0; i < this.elementsLength; i++) {
				var currentItem = this.elements[i]

				if (this.inMotion[i]) {
					this.acceleration[i] = (this.stiffness + (i * 5)) * ((this.Positions[i] - this.scrollY) - Math.round(this.NewPositions[i])) - this.friction * this.velocity[i]
					this.velocity[i] += this.acceleration[i] * this.frameRate
					this.newTop[i] += this.velocity[i] * this.frameRate
					this.inMotion[i] = Math.abs(this.acceleration[i]) >= this.threshold || Math.abs(this.velocity[i]) >= this.threshold
					// this.opacity[i] = 1 - (Math.abs(this.halfViewport - this.newTop[i]) / this.halfViewport)
					css(currentItem, {
						'top': 0,
						'transform': 'translate3d(0,' + this.newTop[i] + 'px,0)',
						'opacity': this.opacity[i]
					})

					// css(currentLegend, {
					//     'transform': 'translate3d(0,' + this.newTop[i] / 2 + 'px,0)'
					// })

					// currentItem.style.webkitFilter = 'blur(' + 0.9 * (Math.abs(this.halfViewport - this.newTop[i]) / this.halfViewport) + 'px)'
					this.NewPositions[i] = this.newTop[i]
				} else {
					this.completeScrolling()
				}
			}

			if (this.animating) this.raf = raf(this.run.bind(this))
		},
		completeScrolling: function () {
			this.animating = false
			raf.cancel(this.raf)
		},
		addScrollEvents: function () {
			this.handlers.onScrolling = this.onScrolling.bind(this)
			window.addEventListener('scroll', this.handlers.onScrolling, false)
		},
		removeScrollEvents: function () {
			window.removeEventListener('scroll', this.handlers.onScrolling, false)
		},
		destroy () {
			window.cancelAnimationFrame(this.handlers.run)
			raf.cancel(this.raf)
			this.removeScrollEvents()
			this.reset()
		}
	},

	data () {
		return {
			instance: null
		}
	}
}

export default ScrollMixin



// WEBPACK FOOTER //
// ./src/mixins/ScrollMixin.js